import store from "@/store";
import AdministrativeStatusModule from "./store";
export default [
  {
    path: "/administrative-status",
    component: () => import("./moduleLayout.vue"),
    beforeEnter(to, _, next) {
      if (!store.hasModule("AdministrativeStatus"))
        store.registerModule(
          "AdministrativeStatus",
          AdministrativeStatusModule
        );
      next();
    },
    children: [
      {
        path: "employees",
        name: "employees",
        component: () => import("./pages/employees/index.vue"),
        meta: {
          pageTitle: "الموظفين ",
          slug: "ngo_employees",
          instructionsSlug: "employees",

          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "الموظفين",
              active: true,
            },
          ],
        },
      },
      {
        path: "volunteers",
        name: "volunteers",
        component: () => import("./pages/employees/index.vue"),
        meta: {
          pageTitle: "المتطوعين ",
          slug: "ngo_volunteers",
          instructionsSlug: "ngo-volunteers",

          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "المتطوعين",
              active: true,
            },
          ],
        },
      },
      {
        path: "volunteers/:id",
        name: "volunteer-show",
        component: () => import("./pages/employees/show.vue"),
        props: true,
        meta: {
          pageTitle: "تفاصيل المتطوع ",
          slug: "ngo_volunteers",
          instructionsSlug: "ngo-volunteers",

          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "المتطوعين",
              to: { name: "volunteers" },
            },
            {
              text: "تفاصيل المتطوع",
              active: true,
            },
          ],
        },
      },
      {
        path: "employees/:id",
        name: "employee-show",
        component: () => import("./pages/employees/show.vue"),
        props: true,
        meta: {
          pageTitle: "تفاصيل الموظف ",
          slug: "ngo_employees",
          instructionsSlug: "employees",

          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "الموظفين",
              to: { name: "employees" },
            },
            {
              text: "تفاصيل الموظف",
              active: true,
            },
          ],
        },
      },
      {
        path: "founders",
        name: "founders",
        component: () => import("./pages/founders-council/index.vue"),
        meta: {
          pageTitle: "المجلس التأسيسي ",
          slug: "ngo_director_boards_founder",
          instructionsSlug: "foundrs",

          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "المجلس التأسيسي",
              active: true,
            },
          ],
        },
      },
      {
        path: "founders/:id",
        name: "founders-show",
        component: () => import("./pages/founders-council/show.vue"),
        props: true,
        meta: {
          pageTitle: "أعضاء المجلس التأسيسي",
          slug: "ngo_director_boards_founder",
          instructionsSlug: "founders",

          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "المجلس التأسيسي",
              to: { name: "founders" },
            },
          ],
        },
      },
      {
        path: "administration-council",
        name: "administration-council",
        component: () => import("./pages/administration-council/index.vue"),
        meta: {
          pageTitle: "مجلس الإدارة ",
          slug: "ngo_director_boards_administrative",
          instructionsSlug: "administration-council",
          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "مجلس الإدارة",
              active: true,
            },
          ],
        },
      },
      {
        path: "administration-council/:id",
        name: "administration-show",
        component: () => import("./pages/administration-council/show.vue"),
        props: true,
        meta: {
          pageTitle: "مجلس الإدارة ",
          slug: "ngo_director_boards_administrative",
          instructionsSlug: "administration-council",
          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "مجلس الإدارة",
              to: { name: "administration-council" },
            },
          ],
        },
      },

      {
        path: "executive-management",
        name: "executive-management",
        component: () => import("./pages/executive-management/index.vue"),
        meta: {
          pageTitle: "الإدارة التنفيذية ",
          slug: "ngo_director_boards_executive",
          instructionsSlug: "executive-management",

          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "الإدارة التنفيذية",
              active: true,
            },
          ],
        },
      },
      {
        path: "executive-management/:id",
        name: "executives-show",
        component: () => import("./pages/executive-management/show.vue"),
        props: true,
        meta: {
          pageTitle: "الإدارة التنفيذية ",
          slug: "ngo_director_boards_executive",
          instructionsSlug: "executive-management",

          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "الإدارة التنفيذية",
              to: { name: "executive-management" },
            },
          ],
        },
      },
      {
        path: "trustees-board",
        name: "trustees-board",
        component: () => import("./pages/trustees-council/index.vue"),
        meta: {
          pageTitle: "مجلس الأمناء ",
          slug: "ngo_director_boards_trustee",
          instructionsSlug: "trustees-board",
          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "مجلس الأمناء",
              active: true,
            },
          ],
        },
      },
      {
        path: "trustees-board/:id",
        name: "trustees-show",
        component: () => import("./pages/trustees-council/show.vue"),
        props: true,
        meta: {
          pageTitle: "مجلس الأمناء ",
          slug: "ngo_director_boards_trustee",
          instructionsSlug: "trustees-board",
          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "مجلس الأمناء",
              to: { name: "trustees-board" },
            },
          ],
        },
      },
      {
        path: "general-info",
        name: "general-info",
        component: () => import("./pages/general-info/index.vue"),
        meta: {
          pageTitle: "المعلومات التنظيمية العامة ",
          slug: "ngo_general_info",
          instructionsSlug: "general-info",

          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "المعلومات التنظيمية العامة",
              active: true,
            },
          ],
        },
      },
      
      {
        path: "meetings",
        name: "meetings",
        component: () => import("./pages/meetings/index.vue"),
        meta: {
          pageTitle: "محاضر الاجتماعات ",
          slug: "ngo_minutes_of_meeting",
          instructionsSlug: "meetings",

          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "محاضر الاجتماعات",
              active: true,
            },
          ],
        },
      },
      {
        path: "general-authority",
        name: "general-authority",
        component: () => import("./pages/general-authority/index.vue"),
        meta: {
          pageTitle: "أعضاء الهيئة العامة ",
          slug: "ngo_general_authority_members",
          instructionsSlug: "ngo_general_authority_members",

          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "أعضاء الهيئة العامة",
              active: true,
            },
          ],
        },
      },
      {
        path: "hold-general-body-meeting",
        name: "hold-general-body-meeting",
        component: () => import("./pages/hold-general-body-meeting/index.vue"),
        meta: {
          pageTitle: "اجتماعات الهيئة العامة",
          slug: "ngo_general_authority_meetings",
          instructionsSlug: "ngo_general_authority_meetings",

          breadcrumb: [
            {
              text: "الوضع الإداري والتنظيمي",
              active: true,
            },
            {
              text: "اجتماعات الهيئة العامة",
              active: true,
            },
          ],
        },
      },

      
    ],
  },
];
